export default __webpack_public_path__ + "fce5627e20737e87f9058fc69463fb00.png";